import useLoad from '../../../components/hooks/useLoad';
import {assistants} from 'constants/url';

function useLoadCollaborator(iD_Instance: number, iD_Course: number) {
  return useLoad(assistants, 'employee_Nr', {iD_Instance, iD_Course});
}

export default useLoadCollaborator;
